import { Image } from 'antd'
import logo from './images/cims.png'

const CIMSLogo: React.VFC = () => (
  <Image
    width={285}
    height={124}
    src={logo}
    style={{ padding: 16 }}
    alt="CIMS"
    preview={false}
  />
)

export default CIMSLogo
